import * as React from 'react';
import styled from 'styled-components';
import { Text, Spacer } from '../parts';
import { Footer } from './parts/Footer';
import { AppStoreModal } from '../components/AppStoreModal';

export const GetMembership: React.FC = () => {
	const [isModalOpen, setIsModalOpen] = React.useState(false);

	const isAndroid = navigator?.userAgent?.toLowerCase().indexOf('android') > -1;
	const isIPhone = navigator?.userAgent?.toLowerCase().indexOf('iphone') > -1;
	const isWeb = !isAndroid && !isIPhone;

	const openAppInStore = () => {
		if (isAndroid) {
			window.location.href = 'https://play.google.com/store/apps/details?id=com.access.liverewards&hl=en&gl=US';
		}
		if (isIPhone) {
			window.location.href = 'https://apps.apple.com/us/app/live-rewards/id1470069033';
		}
	};

	const openIOSApp = () => {
		window.location.href = 'https://apps.apple.com/us/app/live-rewards/id1470069033';
	};

	const openAndroidApp = () => {
		window.location.href = 'https://play.google.com/store/apps/details?id=com.access.liverewards&hl=en&gl=US';
	};

	const handleGetStarted = () => {
		if (isWeb) {
			setIsModalOpen(true);
		} else {
			openAppInStore();
		}
	};

	return (
		<PageBody>
			<AppStoreModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onIOSClick={openIOSApp} onAndroidClick={openAndroidApp} />
			<Container>
				<Spacer size={60} />
				<Text weight="black" size={50} center>
					Get Live Rewards Membership
				</Text>
				<Spacer size={40} />

				<ContentSection>
					<Text weight="semi-bold" size={24}>
						Join Thousands of Savers
					</Text>
					<Spacer size={20} />
					<Text color="#3d3d3d" size={16}>
						Live Rewards membership gives you access to exclusive discounts from thousands of brands and retailers. Start saving today!
					</Text>
				</ContentSection>

				<Spacer size={60} />

				<ContentSection>
					<Text weight="semi-bold" size={24}>
						What's Included
					</Text>
					<Spacer size={20} />
					<BenefitList>
						<BenefitItem>
							<Text weight="bold" size={18}>
								✓ Exclusive Discounts
							</Text>
							<Spacer size={8} />
							<Text color="#3d3d3d" size={16}>
								Access special offers from your favorite brands
							</Text>
						</BenefitItem>

						<Spacer size={20} />

						<BenefitItem>
							<Text weight="bold" size={18}>
								✓ Local Deal Alerts
							</Text>
							<Spacer size={8} />
							<Text color="#3d3d3d" size={16}>
								Get notified about deals near you
							</Text>
						</BenefitItem>

						<Spacer size={20} />

						<BenefitItem>
							<Text weight="bold" size={18}>
								✓ Nationwide Coverage
							</Text>
							<Spacer size={8} />
							<Text color="#3d3d3d" size={16}>
								Use your membership anywhere in the US
							</Text>
						</BenefitItem>

						<Spacer size={20} />

						<BenefitItem>
							<Text weight="bold" size={18}>
								✓ 24/7 Support
							</Text>
							<Spacer size={8} />
							<Text color="#3d3d3d" size={16}>
								Our customer support team is always here to help
							</Text>
						</BenefitItem>
					</BenefitList>
				</ContentSection>

				<Spacer size={60} />

				<ContentSection>
					<Text weight="semi-bold" size={24}>
						Pricing
					</Text>
					<Spacer size={20} />
					<PricingCard>
						<Text weight="black" size={36}>
							$3.99
						</Text>
						<Text color="#666" size={16}>
							per month
						</Text>
						<Spacer size={10} />
						<Text color="#999" size={14}>
							Cancel anytime
						</Text>
						<Spacer size={30} />
						<GetBtn onClick={handleGetStarted}>Download App & Join</GetBtn>
					</PricingCard>
				</ContentSection>

				<Spacer size={60} />

				<ContentSection>
					<Text weight="semi-bold" size={24}>
						How It Works
					</Text>
					<Spacer size={20} />
					<StepContainer>
						<Step>
							<StepNumber>1</StepNumber>
							<Text weight="bold" size={18}>
								Download the App
							</Text>
							<Spacer size={8} />
							<Text color="#3d3d3d" size={16}>
								Get the Live Rewards app on iOS or Android
							</Text>
						</Step>

						<Arrow>→</Arrow>

						<Step>
							<StepNumber>2</StepNumber>
							<Text weight="bold" size={18}>
								Create Account
							</Text>
							<Spacer size={8} />
							<Text color="#3d3d3d" size={16}>
								Sign up with your email or phone number
							</Text>
						</Step>

						<Arrow>→</Arrow>

						<Step>
							<StepNumber>3</StepNumber>
							<Text weight="bold" size={18}>
								Start Saving
							</Text>
							<Spacer size={8} />
							<Text color="#3d3d3d" size={16}>
								Browse deals and save on your purchases
							</Text>
						</Step>
					</StepContainer>
				</ContentSection>

				<Spacer size={100} />
			</Container>
			<Footer />
		</PageBody>
	);
};

const PageBody = styled.div``;

const Container = styled.div`
	max-width: 1200px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0px 20px;

	@media only screen and (max-width: 1200px) {
		padding: 0px 20px;
	}
`;

const ContentSection = styled.div`
	max-width: 800px;
	width: 100%;
`;

const BenefitList = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 20px;
`;

const BenefitItem = styled.div`
	padding: 20px;
	background-color: #f5f5f5;
	border-radius: 8px;
	border-left: 4px solid #165a63;
`;

const PricingCard = styled.div`
	padding: 40px;
	background: linear-gradient(135deg, #91c1f4 0%, #027dfd 100%);
	border-radius: 12px;
	text-align: center;
	color: white;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
`;

const GetBtn = styled.button`
	background-color: white;
	color: #027dfd;
	padding: 12px 30px;
	border: none;
	border-radius: 8px;
	font-size: 16px;
	font-weight: 600;
	cursor: pointer;
	transition: transform 0.2s ease;

	&:hover {
		transform: translateY(-2px);
	}

	&:active {
		transform: translateY(0);
	}
`;

const StepContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 20px;
	flex-wrap: wrap;

	@media only screen and (max-width: 768px) {
		flex-direction: column;
		gap: 30px;
	}
`;

const Step = styled.div`
	flex: 1;
	min-width: 200px;
	text-align: center;
`;

const StepNumber = styled.div`
	width: 50px;
	height: 50px;
	background-color: #165a63;
	color: white;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 24px;
	font-weight: bold;
	margin: 0 auto 15px;
`;

const Arrow = styled.div`
	font-size: 24px;
	color: #165a63;
	font-weight: bold;

	@media only screen and (max-width: 768px) {
		transform: rotate(90deg);
	}
`;
